import React from 'react';
import { Sidebar } from './Sidebar';
import type { SidebarProps } from './Sidebar';

export interface AppShellProps {
  /** Items to render in the built-in Sidebar. */
  sidebarItems?: SidebarProps['items'];
  /** Additional props forwarded to the built-in Sidebar. */
  sidebarProps?: Omit<SidebarProps, 'items'>;
  children: React.ReactNode;
}

export function AppShell({ sidebarItems, sidebarProps, children }: AppShellProps) {
  return (
    <div style={{ display: 'flex', height: '100vh', background: '#f9fafb', overflow: 'hidden' }}>
      {sidebarItems !== undefined && (
        <aside style={{ display: 'flex', flexShrink: 0, position: 'relative' }}>
          <Sidebar items={sidebarItems} {...sidebarProps} />
        </aside>
      )}
      <main style={{ flex: 1, minWidth: 0, overflowY: 'auto' }}>
        {children}
      </main>
    </div>
  );
}
